import { render, staticRenderFns } from "./CasesTags.vue?vue&type=template&id=7a53d7c8&scoped=true&"
import script from "./CasesTags.vue?vue&type=script&lang=js&"
export * from "./CasesTags.vue?vue&type=script&lang=js&"
import style0 from "./CasesTags.vue?vue&type=style&index=0&id=7a53d7c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53d7c8",
  null
  
)

export default component.exports